module.exports = __webpack_public_path__ + "nc_static/media/dd_inventory_information.359fac8f.svg";